import React, {useEffect} from "react";

import {
  HeaderFilter,
  LogoutSection,
} from "./styles";
import MainContainer from "../../application/components/MainContainer";
import DropGroup from "../../application/components/DropIndexesGroup";
import DropMetricsGroup from "../../application/components/DropMetricsGroup";
import DatePicker from "../../application/components/DatePicker";
import moment, {Moment} from "moment";
import AuthActions from "../auth/store/actions";
import { useAppDispatch, useAppSelector} from "../../application/store";
import {
  homeSelector,
  setDateFrom,
  setDateTo,
  setDocumentType,
  setSelectedIndexes,
  setSelectedMetrics
} from "./store/slice";
import {ExportFormat, IndexItem, MetricItem} from "./store/model";
import HomeActions from "./store/actions";
import ExportFormatToggle from "../../application/components/ExportFormatToggle";
import PrimaryButton from "../../application/components/PrimaryButton";
import ApiMetrics from "../../integration/api/ApiMetrics";

const Home = () => {
  const dispatch = useAppDispatch();
  const { data, selectedIndexes, selectedMetrics, dateTo, dateFrom, documentType } = useAppSelector(homeSelector);

  useEffect(() => {
    dispatch(HomeActions.getMetricsAndIndexes());
  }, []);

  const handleSignOut = () => {
    dispatch(AuthActions.signOut());
  }

  const handleSelectIndex = (items: IndexItem[] ) => {
    dispatch(setSelectedIndexes(items))
  }

  const handleSelectMetric = (items: MetricItem[] ) => {
    dispatch(setSelectedMetrics(items))
  }

  const handleSetDateFrom = (date: Moment) => {
    // const formatedDate = date.format("yyyy-MM");
    dispatch(setDateFrom(date));
  };

  const handleSetEndingDate = (date: Moment) => {
    // const formatedDate = date.format("yyyy-MM");
    dispatch(setDateTo(date));
  };

  const handleExportFormat = (type: ExportFormat) => {
    dispatch(setDocumentType(type));
  };

  const handleDownloadFile = async () => {
    const indices = selectedIndexes.map((item) => {
      return {
        id: item.id,
        type: item.type
      }
    });

    const metrics = selectedMetrics.map((item) => {
      return {
        code: item.code,
        displayName: item.displayName,
      }
    });

    try {
      const payload = {
        indices,
        metrics,
        startMonth: dateFrom.format("yyyy-MM"),
        endMonth: dateTo.format("yyyy-MM"),
        format: documentType!
      };

      const response = await ApiMetrics.downloadExportFile(payload);

      let filename = `asset_camp_export_${dateFrom.format("yyyy-MM")}_to_${dateTo.format("yyyy-MM")}.${documentType?.toLowerCase() === "xlsx" ? "xlsx" : "csv"}`;

      let blob: Blob;

      if (documentType === "CSV") {
        const bom = "\uFEFF";
        blob = new Blob([bom, response.data], { type: "text/csv;charset=utf-8;" });
      } else {
        const contentType = response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        blob = new Blob([response.data], { type: contentType });
      }

      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Помилка під час завантаження файлу:", error);
    }
  }

  return (
    <div>
      <MainContainer>
        <LogoutSection>
          <PrimaryButton title="Log out" onClick={handleSignOut} />
        </LogoutSection>
        <HeaderFilter>
          <div style={{display: "flex", gap: "20px"}}>
            <DropGroup
              data={data?.indices || []}
              label="Indexes"
              placeholder="Choose Indexes"
              selected={selectedIndexes || null}
              onSelect={handleSelectIndex}
            />
            <DropMetricsGroup
              data={data?.metrics || []}
              label="Metric"
              placeholder="Choose Metrics"
              selected={selectedMetrics || null}
              onSelect={handleSelectMetric}
            />
          </div>
          <div style={{display: "flex", gap: "20px"}}>
            <DatePicker
              value={dateFrom}
              onChange={handleSetDateFrom}
              label="Date From"
            />
            <DatePicker
              value={dateTo}
              onChange={handleSetEndingDate}
              label="Date To"
            />
          </div>
          <div style={{display: "flex", gap: "20px"}}>
            <ExportFormatToggle
              value={documentType as ExportFormat}
              onChange={handleExportFormat}
            />
          </div>
          <div style={{width: "250px", gap: "20px"}}>
            <PrimaryButton
              title="DOWNLOAD FILE"
              loading={false}
              onClick={handleDownloadFile}
            />
          </div>
        </HeaderFilter>
      </MainContainer>
    </div>
  );
};

export default Home;
